import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 14l-4 -4l4 -4","key":"svg-0"}],["path",{"d":"M5 10h11a4 4 0 1 1 0 8h-1","key":"svg-1"}]]

const IconArrowBackUp = createReactComponent('outline', 'arrow-back-up', 'ArrowBackUp', __iconNode);

export default IconArrowBackUp;